import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import MenuProvAdmin from "../componentsProveedorComercializador/MenuLeftAdmin/menuLeftAdmin";
import MenuPhoneAdmin from "../componentsProveedorComercializador/MenuLeftAdminPhone/menuLeftAdminPhone";
import ProfileProvAdmin from "../ProfileProvAdmin/ProfileProvAdmin";
import UpdatexelprovAdmin from "../UpdateExcelProvAdmin/UpdateExcelProvAdmin";
import CreateExcelProvComercializadorAdmin from "../CreateExcelProvComercializadorAdmin/CreateExcelProvComercializadorAdmin";
import ChangePasswordAdmin from "../ChangePasswordAdmin/ChangePasswordAdmin";
import CreateExelProv from "../CreateExcelProveedor/CreateExcelProveedor";
import ReportProvComercializadorAdmin from "../ReportsProveedorComercializadorAdmin/ReportProvComercializadorAdmin";
import ReportProveedorAdminxml from "../ReportProveedorAdminxml/ReportProveedorAdminxml";
import AnualReport from "../AnualReport/AnualReport";
import Welcome from "../welcome/welcome";
import Pdfdownload from "../ListComerSignature/ListComerCsignature";
import "../IndexProveedorComercializador/IndexProveedorComercializador.css";

const IndexProvAdmin = () => {
  const [viewSeeProv, setViewPageProv] = useState(null);
  const location = useLocation();
  let data = location.state;

  const tipeviewSee = (datos) => {
    setViewPageProv(datos);
  };

  if (!data) {
    const storedData = sessionStorage.getItem("Data");
    if (storedData) {
      data = JSON.parse(storedData);
    }
  } else {
    // Almacena los datos en sessionStorage si están disponibles
    sessionStorage.setItem("Data", JSON.stringify(data));
  }

  return (
    <div className="boxprovmenuallmenu">
      <MenuProvAdmin viewSee={tipeviewSee} />
      <MenuPhoneAdmin viewSee={tipeviewSee} />
      {viewSeeProv === "Perfil" ? <ProfileProvAdmin data={data} /> : null}
      {viewSeeProv === "ExcelComer" ? (
        <CreateExcelProvComercializadorAdmin />
      ) : null}
      {viewSeeProv === "ExcelSales" ? <UpdatexelprovAdmin /> : null}
      {viewSeeProv === "ExcelProv" ? <CreateExelProv /> : null}
      {viewSeeProv === "Contraseña" ? (
        <ChangePasswordAdmin data={data} />
      ) : null}
      {viewSeeProv === "ListProveedordescarga" ? (
        <ReportProvComercializadorAdmin data={data} />
      ) : null}
      {viewSeeProv === "xmldowload" ? (
        <ReportProveedorAdminxml data={data} />
      ) : null}
      {viewSeeProv === "Reports" ? <AnualReport /> : null}
      {viewSeeProv === null && <Welcome data={data} />}
    </div>
  );
};

export default IndexProvAdmin;
